import { defineRouting } from "next-intl/routing";

const localeCookieDomain =
  process.env.NEXT_PUBLIC_LOCALE_COOKIE_DOMAIN?.trim() || undefined;

export const routing = defineRouting({
  locales: ["en", "es", "pt-BR"],
  defaultLocale: "en",
  localePrefix: "always",
  localeCookie: {
    maxAge: 60 * 60 * 24 * 365,
    ...(localeCookieDomain ? { domain: localeCookieDomain } : {}),
  },
});

export type LandingLocale = (typeof routing.locales)[number];

export function isSupportedLocale(value: string): value is LandingLocale {
  return routing.locales.includes(value as LandingLocale);
}

export function normalizeLocale(value: string): LandingLocale {
  return isSupportedLocale(value) ? value : routing.defaultLocale;
}
